'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitlistRequest = undefined;

var _sagaTools = require('@classpass/saga-tools');

var waitlistRequest = exports.waitlistRequest = (0, _sagaTools.makeEntityScaffold)('SAGA.API.JOIN_WAITLIST', function (client) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  return client.waitlist.create(params);
}, { defaultKey: 2 }); /* eslint-disable import/prefer-default-export, no-unused-vars */